import { GET_SEARCH_FILTER_DEFINITIONS_QUERY as PUBLIC_GET_SEARCH_FILTER_DEFINITIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { GET_SEARCH_FILTER_DEFINITIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
export function useFilterDefinitionsQuery() {
  return usePersonalizationQuery({
    app: GET_SEARCH_FILTER_DEFINITIONS_QUERY,
    public: PUBLIC_GET_SEARCH_FILTER_DEFINITIONS_QUERY
  });
}